const Messages = {
    maxFormsReached: "لیست پیش نویس نمیتواند بیش از 10 آیتم باشد",
    deleteFormLimit: "لیست پیش نویس نمیتواند خالی باشد",
    cannotAddFormOnEdit: "امکان افزودن فرم در ویرایش وجود ندارد",
    passwordsNotMatch: "رمز عبور و تکرار آن یکسان نیستند",
    accountApproved: "حساب شما با موفقیت تایید شد",
    verifyCodeSent: "کد تایید ارسال گردید",
    subscriptionFinished:
        "اشتراک شما به پایان رسیده است. لطفا نسبت به تمدید اشتراک کسب و کار خود اقدام فرمایید",
    dashboardQuickAccessLimit: "نوار دسترسی سریع پر شده است",
};

export default Messages;
